angular.module('goodsList', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate', 'ngFileUpload']);



// WEBPACK FOOTER //
// ./src/app/goods-list/goods-list.module.js